import React from "react";
import { CreditAuthorizationUpdateDTO } from "@/types/CreditAuthorizationUpdateDTO";
import { CreditAuthorizationDecision } from "@/types/enums/CreditAuthorizationDecision";

export interface CreditAuthorizationDecisionFieldProps {
  value: CreditAuthorizationUpdateDTO;
  onChange: (value: CreditAuthorizationUpdateDTO) => void;
  disabled?: boolean;
}

export const CreditAuthorizationDecisionField: React.FC<CreditAuthorizationDecisionFieldProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const handleDecisionChange = (decision: CreditAuthorizationDecision) => {
    onChange({
      ...value,
      decision,
    });
  };

  return (
    <div style={{ 
      marginBottom: "40px",
      maxWidth: "500px",
      margin: "0 auto 40px auto"
    }}>
      
      <div style={{ 
        display: "flex", 
        flexDirection: "column",
        gap: "16px"
      }}>
        {/* Accept Button */}
        <button
          type="button"
          onClick={() => handleDecisionChange(CreditAuthorizationDecision.Accept)}
          disabled={disabled}
          style={{
            width: "100%",
            padding: "20px 28px",
            fontSize: "16px",
            fontWeight: "600",
            borderRadius: "8px",
            cursor: disabled ? "not-allowed" : "pointer",
            transition: "all 0.2s ease",
            backgroundColor: value.decision === CreditAuthorizationDecision.Accept 
              ? "var(--ucl-primary)" 
              : "var(--ucl-primary-light)",
            color: value.decision === CreditAuthorizationDecision.Accept 
              ? "white" 
              : "var(--ucl-primary)",
            border: "1px solid var(--ucl-primary)",
            boxShadow: value.decision === CreditAuthorizationDecision.Accept 
              ? "0 4px 6px -1px var(--ucl-shadow)" 
              : "none",
            opacity: disabled ? 0.6 : 1,
          }}
          onMouseEnter={(e) => {
            if (!disabled && value.decision !== CreditAuthorizationDecision.Accept) {
              e.currentTarget.style.backgroundColor = "var(--ucl-primary)";
              e.currentTarget.style.color = "white";
            }
          }}
          onMouseLeave={(e) => {
            if (!disabled && value.decision !== CreditAuthorizationDecision.Accept) {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "var(--ucl-primary)";
            }
          }}
        >
          Accept Credit Check
        </button>

        {/* Decline Button */}
        <button
          type="button"
          onClick={() => handleDecisionChange(CreditAuthorizationDecision.Decline)}
          disabled={disabled}
          style={{
            width: "100%",
            padding: "20px 28px",
            fontSize: "16px",
            fontWeight: "600",
            borderRadius: "8px",
            cursor: disabled ? "not-allowed" : "pointer",
            transition: "all 0.2s ease",
            backgroundColor: value.decision === CreditAuthorizationDecision.Decline 
              ? "var(--ucl-secondary)" 
              : "var(--ucl-secondary-light)",
            color: value.decision === CreditAuthorizationDecision.Decline 
              ? "white" 
              : "var(--ucl-secondary)",
            border: "1px solid var(--ucl-secondary)",
            boxShadow: value.decision === CreditAuthorizationDecision.Decline 
              ? "0 4px 6px -1px var(--ucl-shadow)" 
              : "none",
            opacity: disabled ? 0.6 : 1,
          }}
          onMouseEnter={(e) => {
            if (!disabled && value.decision !== CreditAuthorizationDecision.Decline) {
              e.currentTarget.style.backgroundColor = "var(--ucl-secondary)";
              e.currentTarget.style.color = "white";
            }
          }}
          onMouseLeave={(e) => {
            if (!disabled && value.decision !== CreditAuthorizationDecision.Decline) {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "var(--ucl-secondary)";
            }
          }}
        >
          Decline Credit Check
        </button>
      </div>
    </div>
  );
};
